export enum StorefrontOutlets {
  STOREFRONT = 'cx-storefront',
}
